module.exports = __webpack_public_path__ + "img/p1.1265db8c.png";